import { useLanguage } from '@/lib/LanguageContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { Globe } from 'lucide-react';

const LangBar = () => {
  const { language, changeLanguage } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  const switchToLanguage = (lang) => {
    // Don't do anything if it's the same language
    if (lang === language) {
      return;
    }

    // Get the current path
    const currentPath = location.pathname;
    
    // Calculate new path based on language switch
    let newPath;
    
    if (lang === 'es') {
      // Switching to Spanish
      if (currentPath === '/') {
        newPath = '/es';
      } else if (!currentPath.startsWith('/es')) {
        // Handle translated paths
        if (currentPath === '/services') newPath = '/es/servicios';
        else if (currentPath === '/contact') newPath = '/es/contacto';
        else if (currentPath === '/privacy') newPath = '/es/privacidad';
        else if (currentPath === '/terms') newPath = '/es/terminos';
        else newPath = `/es${currentPath}`;
      } else {
        // Already a Spanish path, don't change
        newPath = currentPath;
      }
    } else {
      // Switching to English
      if (currentPath === '/es') {
        newPath = '/';
      } else if (currentPath.startsWith('/es/')) {
        // Handle translated paths
        if (currentPath === '/es/servicios') newPath = '/services';
        else if (currentPath === '/es/contacto') newPath = '/contact';
        else if (currentPath === '/es/privacidad') newPath = '/privacy';
        else if (currentPath === '/es/terminos') newPath = '/terms';
        else newPath = currentPath.substring(3); // Remove /es prefix
      } else {
        // Already an English path, don't change
        newPath = currentPath;
      }
    }
    
    // Change the language first
    changeLanguage(lang);
    
    // Then navigate to the appropriate page
    navigate(newPath);
  };

  // Get the label and target language
  const targetLang = language === 'en' ? 'es' : 'en';
  
  // Only the language name is a button
  const targetLangDisplay = language === 'en' ? 'Español' : 'English';
  const prefix = language === 'en' ? 'Cambiar idioma a ' : 'Switch language to ';

  return (
    <div className="bg-[#000080] text-white text-right py-1" style={{
      paddingTop: '2px',
      paddingBottom: '2px',
      fontSize: '12px'
    }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="text-xs">{prefix}</span>
        <button
          className="text-xs text-white hover:text-[#40E0D0] transition-colors underline ml-1"
          onClick={() => switchToLanguage(targetLang)}
          title={prefix + targetLangDisplay}
          aria-label={language === 'en' ? 'Cambiar a Español' : 'Switch to English'}
        >
          {targetLangDisplay}
        </button>
      </div>
    </div>
  );
};

export default LangBar; 